import { useState, useEffect, useRef, useCallback } from 'react';
import { LinkTargetProperties } from "global/components/linkSettings/interfaces";
import { PremiumPaywallSignModes } from '../../../../global/paywall/paywallInterfaces';
import { PremiumPaywallMobileSignUp } from "./premiumPaywallMobileSignup";
import { PremiumPaywallMobileSignin } from "./premiumPaywallMobileSignin";
import { useRedirect } from '../../../../global/paywall/useRedirect';


export interface PremiumPaywallState {
  mode: PremiumPaywallSignModes;
  isNewspaper?: boolean;
}
export interface LegalLink {
  url: string;
  target: LinkTargetProperties;
}
interface PremiumPaywallMobileProps {
  setIsRedirecting?: (isRedirect: boolean) => void;
  legalLinks?: { terms: LegalLink; privacy: LegalLink };
  mode?: PremiumPaywallSignModes;
}
export const PremiumPaywallMobile = (props: PremiumPaywallMobileProps) => {
  const [authMode, setAuthMode] = useState<PremiumPaywallState>({
    mode: props.mode || 'signUp',
    isNewspaper: false,
  });
  const [emailOrPhone, setEmailOrPhone] = useState<string>('');
  const [agreesTerms, setAgreeTerms] = useState(false);
  const [password, setPassword] = useState('');
  const [isRedirecting, setIsRedirecting] = useState(false);
  const mainPaywallContainerRef = useRef<HTMLDivElement>(null);
  const isFirstRender: any = useRef(true);


  useRedirect({ enabled: isRedirecting });
  const scrollToForm = useCallback((): void => {
    if (!mainPaywallContainerRef.current) return;
    const el = mainPaywallContainerRef.current;
    if (!el) return;
    setTimeout(() => {
      const header = document.querySelector(".PremiumMutamHeader") as HTMLElement | null;
      let headerOffset = 90;
      if (header) {
        headerOffset = header.offsetHeight + 30;
      }
      const elementPosition = el.getBoundingClientRect().top + window.scrollY;
      const offsetPosition = elementPosition - headerOffset;
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }, 50);
  }, []);



  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    scrollToForm();
  }, [authMode.mode]);

  const getFormByMode = () => {
    if (authMode.mode === 'signUp') {
      return (
        <PremiumPaywallMobileSignUp
          emailOrPhone={emailOrPhone}
          password={password}
          agreesTerms={agreesTerms}
          setEmailOrPhone={setEmailOrPhone}
          setPassword={setPassword}
          setAgreesTerms={setAgreeTerms}
          setMode={setAuthMode}
          setIsRedirecting={setIsRedirecting}
          scrollToForm={scrollToForm}
        />
      );
    }
    return (
      <PremiumPaywallMobileSignin
        emailOrPhone={emailOrPhone}
        password={password}
        agreesTerms={agreesTerms}
        setEmailOrPhone={setEmailOrPhone}
        setPassword={setPassword}
        setAgreesTerms={setAgreeTerms}
        setMode={setAuthMode}
        setIsRedirecting={setIsRedirecting}
        isNewspaper={authMode.isNewspaper}
      />);
  };

  return <div ref={mainPaywallContainerRef as any} className="premium-paywall-mobile">{getFormByMode()}</div>;
};
